var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6834 5.50391H7.186C6.35786 5.50391 5.68652 6.17525 5.68652 7.00338V14.5008C5.68652 15.3289 6.35786 16.0003 7.186 16.0003H14.6834C15.5115 16.0003 16.1829 15.3289 16.1829 14.5008V7.00338C16.1829 6.17525 15.5115 5.50391 14.6834 5.50391Z",
    stroke: "#707070",
    strokeWidth: 1.12461,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.68795 11.5022C1.86324 11.5022 1.18848 10.8274 1.18848 10.0027V2.50534C1.18848 1.68062 1.86324 1.00586 2.68795 1.00586H10.1853C11.0101 1.00586 11.6848 1.68062 11.6848 2.50534",
    stroke: "#707070",
    strokeWidth: 1.12461,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentCopyIcon);
export default __webpack_public_path__ + "static/media/content_copy_icon.4259fd9c963fb4044279efa1dfd4f4b6.svg";
export { ForwardRef as ReactComponent };